<template>
   <button class="offer-button" :class="buttonClass" @click="handleClick">
      <Icon name="link-external-02" color="white" />

      <div class="offer-button-content">
         <span class="offer-title">paxlounge</span>
         <span v-if="showSubtitle" class="offer-subtitle">{{ subtitleText }}</span>
      </div>
   </button>
</template>

<script>
export default {
   name: "PaxConnectButton",
   props: {
      offerSuccess: {
         type: Boolean,
         default: false,
      },
      showSubtitle: {
         type: Boolean,
         default: false,
      },
      customClass: {
         type: String,
         default: "",
      },
   },
   computed: {
      buttonClass() {
         return {
            "offer-success": this.offerSuccess,
            [this.customClass]: this.customClass,
         };
      },
      subtitleText() {
         return this.offerSuccess ? this.$t("hotelBasket_lblConnected2App") : this.$t("hotelBasket_lblConnect2App");
      },
   },
   methods: {
      handleClick() {
         this.$emit("click");
      },
   },
};
</script>
